export default __webpack_public_path__ + "static/media/undies.e7a945d5.svg";